export default __webpack_public_path__ + "static/media/calculator-black.bb224e42.png";